import React from 'react';

interface Props {
  value: number
  level?: number
  lang: string
  isResultInfoModal?: boolean
}


const HealthBadge: React.FC<Props> = (props: Props) => {

  const texts = props.lang === 'sv' ? ['Svag', 'Måttlig', 'Stark', 'Utmärkt'] :
    ['Poor', 'Moderate', 'Good', 'Excellent'];

  const borders = ['#A74338', '#864804', '#38471E', '#38471E','#3E3E76'];
  const colors = ['bg-peach-200', 'bg-orange-200', 'bg-lime-200', 'bg-lime-400','indigo-600'];

  
  let pos = 0
  if (props.level !== undefined) {
    pos = props.level;
  } else {
    if (props.value >= 0.9) pos = 3;
    else if (props.value >= 0.75) pos = 2;
    else if (props.value >= 0.55) pos = 1;
  }

  const blocks = [0, 1, 2, 3];
  const visibleBlocks = blocks.filter((b) => b <= pos);

  return (
    <div className="flex items-center">
      {/* <div>{texts[pos]}</div> */}
      {!props.isResultInfoModal && <div>{texts[pos]}</div>}
      <div className="flex ml-2"
           style={{borderRadius: "9px", width: 64}}>
        {/*<div className="flex ml-2"*/}
        {/*     style={{borderRadius: "9px", width: 64, height: 18, border: "1px solid " + borders[pos]}}>*/}
        {
          blocks.map((block) => {
            const style = {borderRadius: "", borderRight: "", border: ""};
            if (block === 0) {
              style['borderRadius'] = "12px 0 0 12px";
            } else if (block === 3) {
              style['borderRadius'] = "0 12px 12px 0";
            }
            style['border'] = "1px solid " + borders[visibleBlocks.includes(block) ? pos : 4];

            return (
              <div key={"health_" + block}
                   style={style}
                   className={"h-4 w-4 " + colors[visibleBlocks.includes(block) ? pos : 4]}>
              </div>
            )
          })
        }
      </div>
      {props.isResultInfoModal && <div className="ml-2">{texts[pos]}</div>}
    </div>
  )
}

export default HealthBadge;